
import { Options, prop, Vue } from "vue-class-component";

class Props {
  visible = prop<boolean>({
    default: false,
    type: Boolean
  });
  loading = prop<boolean>({
    default: false,
    type: Boolean
  });
  data = prop<any>({
    default: null
  });
}

@Options({
  emits: ["update:visible", "confirm"],
  components: {}
})
export default class ModalConfirmDelete extends Vue.with(Props) {
  get title() {
    return `Hapus Area ${this.data?.areaName ||
      this.data?.name} & Dedicated Kurir?`;
  }

  get message() {
    return "Jika dihapus, area dan dedicated kurir yang sudah diatur akan hilang.";
  }

  textSuccess = "Ya, Hapus";
  textCancel = "Batal";

  onClose() {
    this.$emit("update:visible", false);
  }

  onSubmit() {
    this.$emit("confirm");
  }
}
